import styled from 'styled-components';
import React, { useCallback, useEffect, useState } from 'react';
import { useUploadFile } from '../hooks/useUploadFile';
import { ChatBoxFooter } from '../design_system/ChatBoxFooter';
import { ErrorCodes, useErrorState } from '../stores/errorStateStore';
import { UploadImageDialogWithCaption } from '../design_system/UploadImageDialogWithCaption';
import { isNullable } from 'effect/Predicate';
import { allowedUploadFileExtensions } from '../constants/acceptedUploadFileExtensions';
const PrintIframe = styled.iframe `
  height: 0;
  width: 0;
  position: absolute;
  border: 0;
`;
const HiddenFileInput = styled.input.attrs({ type: 'file' }) `
  display: none;
`;
export const ChatBoxFooterController = ({ isLastMessageCloseEvent = false, isWaitingWelcome = false, onSubmit, onUpload, onDownloadTranscriptClick, }) => {
    const { setErrorState } = useErrorState();
    const [openUploadImageDialog, setOpenUploadImageDialog] = useState(false);
    const [imageToUpload, setImageToUpload] = useState('');
    const [imageUploadTriggered, setImageUploadTriggered] = useState(false);
    useEffect(() => {
        if (!imageUploadTriggered) {
            return;
        }
        setOpenUploadImageDialog(true);
    }, [imageUploadTriggered]);
    const { inputRef, handleFileChange: handleUploadFileChange, handleAttachmentClick, handleUploadFile, } = useUploadFile({
        onError: message => setErrorState({
            code: ErrorCodes.UPLOAD_FILE_ERROR,
            message,
        }),
    });
    const uploadFile = (e) => {
        const imageBlob = handleUploadFileChange(e);
        if (imageBlob) {
            setImageUploadTriggered(true);
            setImageToUpload(imageBlob);
        }
    };
    const handleImageUploadSubmit = useCallback((caption) => {
        var _a, _b;
        setOpenUploadImageDialog(false);
        const selectedFile = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
        if (isNullable(selectedFile)) {
            throw new Error('File not selected');
        }
        onUpload === null || onUpload === void 0 ? void 0 : onUpload(handleUploadFile(selectedFile, caption));
        setImageUploadTriggered(false);
    }, [handleUploadFile, inputRef, onUpload]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ChatBoxFooter, { onSendMessage: onSubmit, disableSendMessage: isLastMessageCloseEvent || isWaitingWelcome, disableAttachmentButton: isLastMessageCloseEvent || isWaitingWelcome, disabledDownloadButton: isWaitingWelcome, onAddAttachmentClick: handleAttachmentClick, onDownloadTranscriptClick: onDownloadTranscriptClick }),
        React.createElement(HiddenFileInput, { onChange: uploadFile, "data-testid": "add-attachment-input", onClick: e => {
                e.target.value = null;
            }, ref: inputRef, accept: allowedUploadFileExtensions.map(ex => `.${ex}`).join(',') }),
        React.createElement(PrintIframe, { id: "print-iframe", "data-testid": "print-iframe" }),
        openUploadImageDialog && (React.createElement(UploadImageDialogWithCaption, { image: imageToUpload, onClose: () => {
                setOpenUploadImageDialog(false);
                setImageToUpload('');
            }, onSubmit: handleImageUploadSubmit }))));
};
